<template>
    <div>
      <Quiz v-if="asyncFlag" :question="question" :cnt="questionSet.length" :result="result" @switch-question="saveAndGetSingleQuestion"></Quiz>
  </div>
</template>

<script>
    import Quiz from '@/page/modules/exam/quizresult'
    export default {
        name: "quizResultContainer",
        components: { Quiz },
        props: ['params'],
        data () {
          return {
            asyncFlag: false,
            outputs: [],
            question: {}, // 当前的题目对象
            questionSet: [], // 题组的所有题目
            examData: {}, // 题组自己的对象
            examId: '', // 生成的examId
            answerParams: { // 需要提交的答案对象
              id: '',
              examId: '',
              paperId: this.params.inputs.paperId,
              isFinish: '0',
              questionId: '',
              answer: '',
              mark: '',
              examStart: ''
            },
            result: {}
          }
        },
        mounted () {
          this.initData()
        },
        methods: {
          createExamId (paperId) { // 生成examId
            var that = this
            return new Promise(function (resolve, reject) {
              that.$api.post(that.$global.examApiPath, '/examExamScore/getExamId', {paperId: paperId}, r => {
                resolve(r.data)
              })
            })
          },
          saveQuizRecord (item) {
            var that = this
            return new Promise(function (resolve, reject) {
              that.$api.post(that.$global.bylApiPath, '/exam/add', item, r => {
                resolve(r.data)
              })
            })
          },
          getExamBy (examId, paperId) {
            var that = this
            return new Promise(function (resolve, reject) {
              that.$api.post(that.$global.examApiPath, '/examPaper/getByExam', {examId: examId, id: paperId}, r => {
                resolve(r.data)
              })
            })
          },
          getQuestionsBy (examId) {
            var that = this
            return new Promise(function (resolve, reject) {
              that.$api.post(that.$global.examApiPath, '/examExamScoreInfo/search', {examId: examId}, r => {
                resolve(r.data)
              })
            })
          },
          getSingleQuestionBy (infoId, getAnswer) {
            var that = this
            return new Promise(function (resolve, reject) {
              that.$api.post(that.$global.examApiPath, '/examQuestion/getByExam', {infoId: infoId, getAnswer: getAnswer}, r => {
                resolve(r.data)
              })
            })
          },
          saveAnswersBy (answers) {
            var that = this
            return new Promise(function (resolve, reject) {
              that.$api.post(that.$global.examApiPath, '/examExamScoreInfo/save', answers, r => {
                resolve(r.data)
              })
            })
          },
          saveAndGetSingleQuestion (o) {
            this.getSingleQuestionBy(this.questionSet[o.nextIdx].id, '1').then((res) => { // 切到下一题
              this.question = res
            })
          },
          getExamResultBy (examId) {
            var that = this
            return new Promise(function (resolve, reject) {
              that.$api.post(that.$global.examApiPath, '/examExamScore/getPaperResult', {id: examId}, r => {
                resolve(r.data)
              })
            })
          },
          initData () {
            this.getExamResultBy(this.params.inputs.examId).then((res) => {
              this.result = res
            })
            this.getQuestionsBy(this.params.inputs.examId).then((res) => {
              this.questionSet = res
              if (this.questionSet) {
                this.getSingleQuestionBy(this.questionSet[0].id, '1').then((res) => {
                  this.asyncFlag = true
                  this.question = res
                })
              }
            })
          }
        }
    }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/modules/course/quizResultContainer.vue